import * as React from "react";
import { HelmReleaseInstance } from "../marketplace/types/release";
import { DOCS_URL } from "../../envVariables";
import { CodeSnippet } from "../../components/generic/codeSnippet/codeSnippet";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

interface Props {
  release: HelmReleaseInstance;
}
export const ReleaseUninstall: React.FC<Props> = ({ release }) => {
  const org = useAppSelector(selectOrg);

  return (
    <>
      <div className={`mt-4 p-4 border`}>
        <p>
          Uninstall via terminal using the{" "}
          <a href={`${DOCS_URL}/guides/cpln-helm#uninstall-a-release`} target="_blank" className="color-link">
            Helm Uninstall
          </a>{" "}
          CLI command.
        </p>
        <CodeSnippet code={`cpln helm uninstall ${release.name || "{name}"}  --org ${org}`} className="mt-3 text-sm" />
      </div>
    </>
  );
};
